import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Intl } from '@erecruit/core';
import { ButtonContainer } from '@erecruit/modules';
import { H1, Modal, Button, Form, FormItem, TextArea } from '@erecruit/ui-kit';
import { selectors, cancelShift } from './state/reducer';
import {
  CancelShiftData,
  CancelShiftModalForm,
  CancelShiftModalProps,
} from './types';

const { FormattedMessage, injectIntl } = Intl;

const ModalTitle = (
  <H1>
    <FormattedMessage id={messageIds.vms.shiftSearch.actions.text} />
  </H1>
);

const PageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage id={messageIds.vms.shiftSearch.actions.cancelShift} />
  </H1>
);

const onSubmit = (form: CancelShiftModalForm, props: CancelShiftModalProps) => {
  const { cancelShift, filterState, shiftSearch, setCloseModalVisible } = props;
  setCloseModalVisible(false);
  const data: CancelShiftData = {
    filter: filterState,
    positionName: shiftSearch.position.name,
    shiftName: shiftSearch.shiftType.name,
    params: {
      shiftId: shiftSearch.id,
      note: form.note ?? '',
    },
  };
  cancelShift(data);
};

const CancelShiftModal: FC<CancelShiftModalProps> = props => {
  const onCancel = () => props.setCloseModalVisible(false);

  return (
    <Modal
      title={ModalTitle}
      pageTitle={PageTitle}
      visible={props.closeModalVisible}
      onCancel={onCancel}
      footer={false}
      destroyOnClose
    >
      <Form
        onValidFieldsSubmit={values =>
          onSubmit(values as CancelShiftModalForm, props)
        }
      >
        <FormItem
          id={nameof<CancelShiftModalForm>(x => x.note)}
          label={props.intl.formatMessage({
            id: messageIds.vms.shiftSearch.actions.cancellationNote,
          })}
        >
          <TextArea autoSize={{ minRows: 4 }} />
        </FormItem>
        <ButtonContainer>
          <Button size="large" onClick={onCancel}>
            <FormattedMessage
              id={messageIds.vms.shiftSearch.actions.cancelText}
            />
          </Button>
          <Button htmlType="submit" size="large" key="confirm" type="primary">
            <FormattedMessage id={messageIds.vms.shiftSearch.actions.okText} />
          </Button>
        </ButtonContainer>
      </Form>
    </Modal>
  );
};

export default injectIntl(
  connect(selectors.selectShiftSearchState, {
    cancelShift: cancelShift,
  })(CancelShiftModal),
);
